import React, { useEffect, useState } from "react";
import "./index.css";
import { AmbikaVenderApi } from "../config";
import axios from "axios";
import StatusModal from "./StatusModal";
import RouteCard from "./RouteCard";
import CustomerCard from "./CustomerCard";
import { FaSync } from "react-icons/fa"; // Import refresh icon
import { db } from "../../firebase"; // Import Firebase database
import { ref, onValue } from "firebase/database";
import { useProfile } from "../ProfileContext";

const staticStatusCodes = [
  {
    id: 1,
    code: "U",
    name: "Order Placed with Urgent (U)",
    color_code: "#FF6969",
  },
  {
    id: 2,
    code: "P",
    name: "Order Placed with Packing (P)",
    color_code: "#FF6969",
  },
  { id: 3, code: "O", name: "Order Placed with O", color_code: "#FF6969" },
  {
    id: 4,
    code: "Z",
    name: "Order with Placed with Partially Ready (Z)",
    color_code: "#FF6969",
  },
];

const Dashboard = () => {
  const [routeWiseProduct, setRouteWiseProduct] = useState([]);
  const [customerOrderProduct, setCustomerOrderProduct] = useState([]);
  const [productStatusCode, setProductStatusCode] = useState();
  const [showColorCodeModal, setShowColorCodeModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const ambikaUserToken = localStorage.getItem("ambikaUserToken");
  const ambikaUserId = localStorage.getItem("ambikaUserId");
  const { profileData } = useProfile();

  const getRoutewiseProduct = () => {
    return axios
      .post(
        `${AmbikaVenderApi}/vendor/vendorRoutewiseProduct`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setRouteWiseProduct(res?.data?.data || []);
      });
  };

  const getCustomerOrderProductList = () => {
    return axios
      .post(
        `${AmbikaVenderApi}/vendor/customerOrderProductList`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setCustomerOrderProduct(res?.data?.data);
      });
  };

  const getProductStatusCode = () => {
    return axios
      .get(`${AmbikaVenderApi}/vendor/productStatusCode`, {
        headers: { Authorization: `Bearer ${ambikaUserToken}` },
      })
      .then((res) => {
        setProductStatusCode(res?.data?.data);
      });
  };

  const refreshAllData = () => {
    setIsRefreshing(true);
    Promise.all([
      getRoutewiseProduct(),
      getCustomerOrderProductList(),
      getProductStatusCode(),
    ])
      .catch((err) => {
        console.error("Error refreshing data:", err);
      })
      .finally(() => {
        setIsRefreshing(false);
      });
  };

  useEffect(() => {
    refreshAllData();
  }, []);

  useEffect(() => {
    const statusRef = ref(db, `orders/${profileData.branchId}`);
    const unsubscribe = onValue(statusRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        refreshAllData();
        console.log("Updated order status from Firebase", data);
      }
    });

    return () => unsubscribe();
  }, [profileData.branchId]);

  return (
    <div className="container-fluid py-4 px-lg-4">
      <div className="dashboard-header mb-3">
        <h5 className="text-muted">Dashboard</h5>
      </div>

      <StatusModal
        show={showColorCodeModal}
        onClose={() => setShowColorCodeModal(false)}
        productStatusCode={productStatusCode}
      />

      <div className="row">
        {/* First Column (10-15%): Status Information */}
        <div className="col-12 col-lg-2 col-xl-2 mb-4">
          <div className="card shadow-sm border-0 h-100" style={{ borderRadius: '8px' }}>
            <div className="card-body p-3">
              <h6 className="fw-bold mb-3" style={{ fontSize: '13px', color: '#495057' }}>Status Information</h6>
              <div className="d-flex flex-column gap-2 mb-3">
                {staticStatusCodes?.map((status) => (
                  <div key={status.id} className="d-flex align-items-center">
                    <div style={{ backgroundColor: '#fff', color: '#000', border: '1.5px solid #212529', minWidth: 22, height: 22, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, marginRight: 8, fontWeight: 'bold' }}>{status.code}</div>
                    <span style={{ fontSize: 12, color: '#495057', lineHeight: '1.2' }}>{status.name}</span>
                  </div>
                ))}
                {productStatusCode?.map((status) => (
                  <div key={status.id} className="d-flex align-items-center">
                    <div style={{ backgroundColor: status.color_code, minWidth: 22, height: 22, borderRadius: '50%', marginRight: 8 }}></div>
                    <span style={{ fontSize: 12, color: '#495057', lineHeight: '1.2' }}>{status.name}</span>
                  </div>
                ))}
              </div>
              <div className="p-2 bg-light rounded border" style={{ fontSize: 11, color: '#6c757d' }}>
                <strong className="d-block mb-1">Format:</strong>
                Order Qty / Ready Qty / Delivered Qty 
                <hr className="my-1"/>
                <strong className="d-block mb-1">Example:</strong> 
                32/23/20
              </div>
            </div>
          </div>
        </div>

        {/* Second Column (20-25%): Route Trucks */}
        <div className="col-12 col-md-5 col-lg-3 col-xl-3 mb-4">
          <div className="row gy-3">
            {routeWiseProduct?.length > 0 ? (
              routeWiseProduct.map((route) => (
                <RouteCard
                  key={route.route_id}
                  route={route}
                  onInfoClick={() => setShowColorCodeModal(true)}
                  productStatusCode={productStatusCode}
                  staticStatusCodes={staticStatusCodes}
                />
              ))
            ) : (
              <div className="col-12">
                <div className="alert alert-info" style={{ fontSize: '13px' }}>No route data available</div>
              </div>
            )}
          </div>
        </div>

        {/* Third Column (60-70%): Customers */}
        <div className="col-12 col-md-7 col-lg-7 col-xl-7">
          <div className="row gy-3">
            {customerOrderProduct?.map((custId, idx) => (
              <CustomerCard
                key={`${custId}-${idx}`}
                details={custId}
                onInfoClick={() => setShowColorCodeModal(true)}
                refreshAllData={refreshAllData}
                productStatusCode={productStatusCode}
                staticStatusCodes={staticStatusCodes}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
